<template>
  <div v-if="isLoading" class="w-100" style="height: 200px;"><div class="loader m-auto"></div></div>
  <div v-else>
    <table class="table table-striped">
      <thead>
        <tr>
          <th scope="col"><span class="h5 font-weight-bold">#</span></th>
          <th scope="col"><span class="h5 font-weight-bold">{{ $t("message.business_score.search_input") }}</span></th>
          <th scope="col"><span class="h5 font-weight-bold">{{ $t("message.business_score.language") }}</span></th>
          <th scope="col"></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(hist, index) in histories">
          <td class="small" scope="row"><span class="h6">{{ index + 1 }}</span></td>
          <td class="small"><span class="h6">{{ hist.company }}</span></td>
          <td class="small"><span class="h6">{{ hist.locale }}</span></td>
          <td>
            <button class="btn btn-primary btn-sm p-0 h-auto" @click="() => handleToggleDetail(hist.response)">
              <span class="m-0 px-3 py-2">{{ $t("message.business_score.view") }}</span>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
    <b-modal v-model="modalShow" hide-footer lazy size="xl">
      <template v-if="response">
        <div class="mr-0 ml-auto mb-3" style="width: fit-content">
          <js-pdf :pageMarginsInPx="[30, 30, 30, 30]" :pageFullWidthInPx="1400" :filename="'detail.pdf'">
            <template v-slot="pdfProps">
              <ItemsList
                :data="response.data.items"
                :imLoaded="pdfProps.childFullyLoaded"
              />
            </template>
          </js-pdf>
        </div>
        <ItemsList :data="response.data.items" />
      </template>
    </b-modal>
  </div>
</template>
<script>
import ItemsList from "./itemsList.vue";
export default {
  name: "History",
  components: { ItemsList },
  data() {
    return {
      isLoading: true,
      response: null,
      modalShow: false,
      histories: [
        // {
        //   "name": null,
        //   "idcard": null,
        //   "pageno": null,
        //   "dataType": null,
        //   "dataId": null,
        //   "locale": "ru",
        //   "response": "{\"msg\": \"Запрос выполнен успешно\", \"code\": \"00\", \"data\": {\"items\": [{\"dom\": \"\", \"tel\": \"\", \"year\": \"2023\", \"email\": \"\", \"totalTax\": 35.26, \"totalSale\": 634.0, \"netProfits\": 98.76, \"postalcode\": \"\", \"totalAsset\": 265.09, \"primarySale\": 634.0, \"totalEquity\": 26.54, \"totalProfits\": 103.95, \"totalLiability\": 238.55}]}, \"orderno\": \"2504110223207151737\"}"
        // }
      ],
    };
  },
  async mounted() {
    this.isLoading = true;
    try {
      const res = await axios.get(window.base + "/PersonalLegalInfo/GetSearchHistory?searchType=4");
      const reversed = res.data.reverse();
      this.histories = reversed.map((item) => ({
        ...item,
        response: JSON.parse(item.response),
      }));
      this.isLoading = false;
    } catch (e) {
      console.error("GetSearchHistory?searchType=4", e);
      this.isLoading = false;
    }
  },
  methods: {
    handleToggleDetail(response = null) {
      this.response = response;
      this.modalShow = response !== null;
    },
  },
};
</script>
<style>
.loader {
  border: 16px solid #f3f3f3;
  border-radius: 50%;
  border-top: 16px solid #3498db;
  width: 120px;
  height: 120px;
  -webkit-animation: spin 2s linear infinite;
  /* Safari */
  animation: spin 2s linear infinite;
}

/* Safari */
@-webkit-keyframes spin {
  0% {
    -webkit-transform: rotate(0deg);
  }

  100% {
    -webkit-transform: rotate(360deg);
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
</style>